<template>
  <div class="createCurriculumSystem">
    <el-page-header
      content="课程详情"
      @back="
        $router.push({
          path: '/school-home-page/Campuscourses',
        })
      "
    >
    </el-page-header>

    <el-row>
      <el-col :span="24">
        <div class="formwrapper">
          <el-form
            class="form-style"
            label-position="left"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            size="small"
            label-width="100px"
          >
            <el-form-item label="排序号" required prop="sort_num">
              <el-input-number
                v-model="ruleForm.sort_num"
                :precision="0"
              ></el-input-number>
            </el-form-item>

            <el-form-item label="体系名称" required prop="curriculum_name">
              <el-input
                v-model="ruleForm.curriculum_name"
                placeholder="请输入名称"
                style="width: 300px"
              ></el-input>
            </el-form-item>

            <el-form-item label="课程简介" required>
              <el-input
                type="textarea"
                v-model="ruleForm.curriculum_desc"
                placeholder="请输入体系的简介"
                style="width: 300px"
              ></el-input>
            </el-form-item>

            <el-form-item label="所属科目" required prop="subject_id">
              <el-select
                v-model="ruleForm.subject_id"
                placeholder="请选择"
                style="width: 300px"
                disabled
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="(item, index) of subjectList"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="授课类别" required prop="teaching_type">
              <el-select
                v-model="ruleForm.teaching_type"
                placeholder="请选择"
                style="width: 300px"
                disabled
              >
                <el-option label="面授课" :value="1"></el-option>
                <el-option label="直播课" :value="2"></el-option>
                <el-option label="录播课" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="*难度等级">
              <el-rate v-model="ruleForm.difficulty"></el-rate>
            </el-form-item>
            <el-form-item label="*适合年级">
              <el-input
                v-model="ruleForm.for_grade"
                placeholder="请输入适合年级"
                style="width: 300px"
              ></el-input>
            </el-form-item>

            <el-form-item label="课程类型" required prop="curriculum_type">
              <el-select
                v-model="ruleForm.curriculum_type"
                placeholder="请选择"
                style="width: 300px"
              >
                <el-option label="体验课" :value="1"></el-option>
                <el-option label="常规课" :value="2"></el-option>
                <el-option label="短期课" :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="课程封面" required prop="imgList">
              <el-upload
                action=""
                :http-request="uploadFile"
                :on-remove="handleRemove"
                :on-change="handleChangeFile1"
                :auto-upload="false"
                :limit="1"
                :file-list="ruleForm.imgList"
                list-type="picture"
                style="width: 300px"
              >
                <el-button size="mini" type="primary" plain
                  >点击上传<i class="el-icon-upload el-icon--right"></i
                ></el-button>
                <div slot="tip" class="el-upload__tip">
                  <span style="color: red">推荐尺寸(520*360)</span>
                  只能上传jpg/png文件，且不超过2mb
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="formbtn">
          <el-button
            @click="addOrUpdateSchoolSelfCurriculum"
            type="primary"
            size="small"
            >修改</el-button
          >

          <el-button
            type="primary"
            size="small"
            @click="
              $router.push({
                path: '/school-home-page/Campuscourses',
              })
            "
            >取消</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getCurriculum,
  addOrUpdateSchoolSelfCurriculum,
} from '@/api/educational'

import { getZoneSchoolSubjectList } from '@/api/community'

import uploadFile from '@/config/uploadFileSchool'

export default {
  name: 'edit-Campuscourses',
  data() {
    return {
      uploadFileTime: false,
      subjectList: [],
      ruleForm: {
        difficulty: null,
        for_grade: '',

        subject_id: '',
        teaching_type: '',
        number_of_courses: 1,
        sort_num: 1,
        curriculum_name: '',
        curriculum_url: [],
        curriculum_classes_list: [],
        curriculum_type: '', //课程类型
        curriculum_desc: '', //课程简介
        imgList: [],
        img_url: '', //课程体系缩略图
      },
      curriculum_name: '',
      //课程参数
      curriculumRow: {
        created_time: null,
        subject_id: null,
        curriculum_id: null,
        title: null,
        sort_num: null,
        ppt_url: '',
        desc: null,
        other_meterial_url: '',
        train_video_url: '', //师训视频
        exampal_video_url: '', //课堂实录
        lession_plan_url: '', //备课指南
        exampal_work_url: '', //课堂成果
        teach_template_url: '', //授课模板
        home_template_url: '', //作业模板
        stu_note_url: '', //学生讲义
        imgList1: [], //讲次缩略图
        pptList: [], //ppt 课件
        planList: [], //备课指南
        train_videoList: [], //师训视频
        example_videoList: [], //课堂实录视频
        stu_noteList: [], //学生讲义参数
        exampal_workList: [], //课堂成果sb3 文件
        teach_templateList: [], //授课模板 sb3
        home_templateList: [], //课后作业 sb3
        learn_videoList: [], //录播视频参数
        id: null,
      },

      total_storage: 0, //课程资料空间

      edit_state: 'add_curriculum',
      addtitle: '新增讲次',

      curriculumRowIndex: 0,
      rules: {
        curriculum_name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        teaching_type: [
          { required: true, message: '请选择类别', trigger: 'change' },
        ],
        number_of_courses: [
          { required: true, message: '请输入课程次数', trigger: 'change' },
        ],
        sort_num: [
          { required: true, message: '请输入排序号', trigger: 'change' },
        ],
        subject_id: [
          { required: true, message: '请选择科目', trigger: 'change' },
        ],
        desc: [
          { required: true, message: '请填写讲次简介', trigger: 'change' },
        ],
      },
    }
  },
  mounted() {
    this.getZoneSchoolSubjectList()
    this.getCurriculum({}, true)
  },
  methods: {
    //新建校区课程体系
    addOrUpdateSchoolSelfCurriculum() {
      console.log('提交课程体系参数')
      console.log(this.ruleForm)

      addOrUpdateSchoolSelfCurriculum({
        difficulty: this.ruleForm.difficulty,
        for_grade: this.ruleForm.for_grade,
        curriculum_id: this.$route.query.id,
        title: this.ruleForm.curriculum_name, //体系名称
        subject_id: this.ruleForm.subject_id, //科目id
        teaching_type: this.ruleForm.teaching_type, //授课类型
        sort_num: this.ruleForm.sort_num, //排序号
        curriculum_data_url: '', //课程资料 [{ name: '课程资料1', 'url': 'http://www.baidu.com', sort_num: 1 }]
        curriculum_type: this.ruleForm.curriculum_type, // 课程类型
        curriculum_desc: this.ruleForm.curriculum_desc, //课程描述
        img_url: this.ruleForm.imgList[0].url, //课程封面缩略图
      }).then((res) => {
        console.log('新建课程体系')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.$router.push({ name: 'Campuscourses' })
        }
      })
    },

    // 下载文件
    downLoad(url) {
      if (url) {
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件未上传')
      }
    },

    // 获取课程体系详情
    getCurriculum() {
      getCurriculum(
        {
          curriculum_id: this.$route.query.id,
        },
        true
      ).then((res) => {
        console.log(res, 456)
        ;(this.ruleForm.difficulty = res.curriculum[0].difficulty),
          (this.ruleForm.for_grade = res.curriculum[0].for_grade),
          (this.ruleForm.curriculum_name = res.curriculum[0].title)
        this.curriculum_name = res.curriculum[0].title
        this.ruleForm.subject_id = res.curriculum[0].subject_id
        this.ruleForm.teaching_type = res.curriculum[0].teaching_type
        this.ruleForm.sort_num = res.curriculum[0].sort_num
        this.ruleForm.number_of_courses = res.curriculum[0].number_of_courses
        this.ruleForm.curriculum_url = JSON.parse(
          res.curriculum[0].curriculum_data_url
        )
        this.ruleForm.curriculum_classes_list = res.curriculum_material_list
        this.ruleForm.curriculum_desc = res.curriculum[0].curriculum_desc
        this.ruleForm.curriculum_type = res.curriculum[0].curriculum_type

        this.ruleForm.imgList = [
          {
            url: res.curriculum[0].img_url,
            name: res.curriculum[0].img_url.split('/')[
              res.curriculum[0].img_url.split('/').length - 1
            ],
          },
        ]

        console.log('课程体系-修改教学计划')
        console.log(res)

        //添加讲次信息
        this.curriculumRow.subject_id = res.curriculum[0].subject_id
        this.curriculumRow.curriculum_id = res.curriculum[0].id
      })
    },

    // 获取科目
    getZoneSchoolSubjectList() {
      getZoneSchoolSubjectList({}).then((res) => {
        this.subjectList = res.subjectList
      })
    },

    EditWorkData() {
      let routeData = this.$router.resolve({
        path: '/background/pyeditor',
        query: {},
      })
      window.open(routeData.href, '_blank')
    },

    // 编辑取消
    quitaddCourse() {
      this.curriculumRow.created_time = null
      this.curriculumRow.curriculum_id = null
      this.curriculumRow.id = null
      this.curriculumRow.desc = null
      this.curriculumRow.sort_num = null
      this.curriculumRow.subject_id = null
      this.curriculumRow.title = null
      this.curriculumRow.desc = null
      this.curriculumRow.url = null
      this.curriculumRow.ppt_url = null

      this.curriculumRow.other_meterial_url = null

      this.curriculumRow.train_video_url = null
      this.curriculumRow.exampal_video_url = null
      this.curriculumRow.lession_plan_url = null
      this.curriculumRow.exampal_work_url = null
      this.curriculumRow.teach_template_url = null
      this.curriculumRow.home_template_url = null
      this.curriculumRow.stu_note_url = null

      this.curriculumRowIndex = 0
      this.curriculumRow.imgList1 = []

      this.dialogVisible = false
    },
    uploadFile() {},
    handleRemove(file, fileList, status) {
      if (status === 'curriculum_url') {
        this.ruleForm.curriculum_url = fileList
      } else {
        this.curriculumRow[status] = fileList
      }
    },
    async handleChangeFile(file, fileList, status, index) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, status, index)
      }
    },

    //课程体系缩略图
    async handleChangeFile1(file, fileList) {
      console.log('上传课程体系缩略图')
      const nameIndex = file.name.lastIndexOf('.')
      const isAllowedType = ['.jpeg', '.png', '.jpg'].includes(
        file.name.substring(nameIndex)
      )
      // const isAllowedSize = file.size / 1024 < 500 // 小于500kb
      const isAllowedSize = file.size / 1024 / 1024 < 2 // 小于2M

      if (!isAllowedType) {
        this.$message.error('只能上传 JPG/PNG 格式的图片!')
        this.ruleForm.imgList.pop()
      } else if (!isAllowedSize) {
        this.$message.error('上传的图片大小不能超过 2mb!')
        this.ruleForm.imgList.pop()
      }
      if (isAllowedType && isAllowedSize && !this.uploadFileTime) {
        await this.uploadFileOss(fileList, 'img_url')
      }
    },

    async uploadFileOss(list, status) {
      this.uploadFileTime = true

      await uploadFile(
        list,
        this.$store.state.user.userInfo.code +
          '/owncouse/' +
          this.$route.query.id
      ).then((res) => {
        if (status === 'curriculum_url') {
          console.log('curriculum_url')
          this.ruleForm.curriculum_url = res
        } else if (status === 'img_url') {
          this.ruleForm.imgList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
            },
          ]

          console.log('this.ruleForm.img_url')
          console.log(this.ruleForm.img_url)
        } else if (status === 'course_img_url') {
          this.curriculumRow.imgList1 = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('this.curriculumRow.imgList1')
          console.log(this.curriculumRow.imgList1)
        } else if (status === 'course_ppt') {
          this.curriculumRow.pptList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('课件参数')
          console.log(res)
          console.log(this.curriculumRow.pptList)
        } else if (status === 'course_plan_url') {
          this.curriculumRow.planList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('备课指南参数')
          console.log(res)
          console.log(this.curriculumRow.planList)
        } else if (status === 'course_train_videourl') {
          this.curriculumRow.train_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('师训视频参数')
          console.log(res)
          console.log(this.curriculumRow.train_videoList)
        } else if (status === 'course_example_videourl') {
          this.curriculumRow.example_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('课堂实录视频参数')
          console.log(res)
          console.log(this.curriculumRow.example_videoList)
        } else if (status === 'course_stu_noteurl') {
          this.curriculumRow.stu_noteList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('学生讲义参数')
          console.log(res)
          console.log(this.curriculumRow.stu_noteList)
        } else if (status === 'course_exampal_work_url') {
          this.curriculumRow.exampal_workList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('课堂成果')
          console.log(res)
          console.log(this.curriculumRow.exampal_workList)
        } else if (status === 'course_teach_templateurl') {
          this.curriculumRow.teach_templateList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('授课模板')
          console.log(res)
          console.log(this.curriculumRow.teach_templateList)
        } else if (status === 'course_home_templateurl') {
          this.curriculumRow.home_templateList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('授课模板')
          console.log(res)
          console.log(this.curriculumRow.home_templateList)
        } else if (status === 'course_learn_videoeurl') {
          this.curriculumRow.learn_videoList = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
              length: res[0].length,
            },
          ]

          console.log('录播视频参数')
          console.log(res)
          console.log(this.curriculumRow.learn_videoList)
        } else {
          this.curriculumRow[status] = res
        }

        this.uploadFileTime = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.createCurriculumSystem {
  background-color: #ffffff;
  padding: 15px;
  margin: 10px;
  box-sizing: border-box;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .formwrapper {
    margin-left: 15px;
  }
  .formbtn {
    padding-left: 15px;
  }
  .addcourse {
    text-align: right;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 0 20px;
  }
  .table-style {
    padding-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
